
<!-- Home Section -->
<section id="home" class="container-fluid home-Section">
  <div class="container content-main text-center">
    <h2 class="main-text">Agility. Integrity. Teamwork</h2>
    <!--    <h2 class="main-text">Fighting Covid-19: We are at the forefront</h2>-->
    <!--    <p class="text-center text-white" style=""><a style="text-decoration: none;color: white" routerLink="/insights/fighting-covid-19-we-are-at-the-forefront">Find out more...</a></p>-->
  </div>
</section>
<!-- Portfolio Section -->
<section id="portfolio" class="container-fluid portfolio-Section">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <img src="assets/images/IrvineTek-Digital-Transformation.png" class="img-fluid" alt="Portfolio" style="width: 85%;margin: auto">
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 chs-text">
        <h3 class="pt-5 mb-3"><b>Agile Digital Transformation</b></h3>
        <p>Digital Transformation itself has undergone rapid transition in the last decade e.g., cloud environments, remote maintenance, monitoring and upgradation now offer lower operational costs.</p>
        <p>Large corporations always had means of adopting new technology. However, now small & medium enterprises are enjoying level-playing  field as well. They can now focus on providing excellent working environment & customer experience while customized IT applications take care of back-office, front-office and other services.</p>
        <h4 class="">Why Is It Necessary</h4>
        <ul class="pl-4" style="margin-bottom: 40px">
          <li>Everyone expects integrated solutions</li>
          <li>Empowers employees empowerment for productivity</li>
          <li>Enables business collaborations & integrations</li>
          <li>Provides security as top priority</li>
          <li>Helps in better & faster decision making</li>
        </ul>
      </div>
    </div>
  </div>
</section>
<!-- Twidlee Section -->
<section id="twidlee" class="container-fluid twidlee-Section">
  <div class="container py-5">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <div class="">
          <h3 class="mb-3"><b>IrvineTek:</b></h3>
          <p>We are qualified professionals with extensive experience of digital transformation & consulting services for fortune 500 companies. Our team has successfully delivered over $2B worth of technology projects for various industries.</p>
          <p>We employ agile methodologies for optimization and automation of our client's operations. Efficient use of modern technologies like data analytics, artificial intelligence, internet of things fuel digital growth and built culture of collaboration, efficiency & transparency.</p>
          <h4 class="">We work by:</h4>
          <ul class="pl-4">
            <li>Conducting business with integrity</li>
            <li>Building strong ethical & inclusive culture</li>
            <li>Adhering to best practices & policies</li>
            <li>Promoting digital responsibility</li>
            <li>Fostering compliance & transparency</li>
          </ul>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-12 d-flex align-items-center">
        <img src="../../../assets/images/IrvineTek-Who-we-are.png" class="img-fluid" alt="">
      </div>
    </div>
  </div>
</section>
<!-- Planet Hiring Section -->
